import React from "react";
import IVFSlider from "../components/layout/IVFSlider";
import ImageTextSection from "../components/layout/ImageTextSection";
import CallToActionBanner from "../components/layout/CallToActionBanner";
import BlogCardsSection from "../components/layout/BlogCardsSection";
import HormoneTestsSlider from "../components/layout/HormoneTestsSlider";
import { ivfItems } from "../data/ivfItems";
import { kadinHastaliklariBlogCards } from "../data/blogCards";
import { balanslamaCards } from "../data/balanslamaCards";
import { hormoneTests } from "../data/hormoneTests";
import TupBebekHakkimizda from "../assets/images/tupbebek/tupbebekHakkimizda.png"

const TupBebekPage: React.FC = () => {
    return (
        <>
            <IVFSlider
                title="Tüp Bebek"
                items={ivfItems}
            />

            <ImageTextSection
                image={TupBebekHakkimizda}
                imageAlt="Megapark Hastanesi"
                title="Hakkımızda"
                description="Megapark Hastanesi, 2014 yılında kurulmuş bulunan Marsam Özel Sağlık Hizmetleri A.Ş’nin sağlık hizmetleri projesidir. Hastane binası inşaatı ve medikal cihazlar tamamlanarak 2015 yılının Ocak ayında hasta kabule başlanmıştır.Megapark Hastanesi gelişmiş tıp teknolojisinin yanında üstün bilgi ve yetenekteki uzman kadrosu ile sağlık hizmetleri alanında hizmet sunmaktadır. Megapark Hastanesi sağlık hizmetlerine verdiği önemin yanı sıra, hasta ve hasta yakını memnuniyetini esas alan hasta ilişkileri hizmetleri ile hastaların isteklerine cevap vermeyi görev olarak benimsiyor. Bu doğrultuda, idari ve medikal alanında tüm çalışmalarına sunduğu..."
                fullDescription="Megapark Hastanesi, 2014 yılında kurulmuş bulunan Marsam Özel Sağlık Hizmetleri A.Ş’nin sağlık hizmetleri projesidir. Hastane binası inşaatı ve medikal cihazlar tamamlanarak 2015 yılının Ocak ayında hasta kabule başlanmıştır.
Megapark Hastanesi gelişmiş tıp teknolojisinin yanında üstün bilgi ve yetenekteki uzman kadrosu ile sağlık hizmetleri alanında hizmet sunmaktadır. Megapark Hastanesi sağlık hizmetlerine verdiği önemin yanı sıra, hasta ve hasta yakını memnuniyetini esas alan hasta ilişkileri hizmetleri ile hastaların isteklerine cevap vermeyi görev olarak benimsiyor. Bu doğrultuda, idari ve medikal alanında tüm çalışmalarına sunduğu eğitimlerin kalitesinin en üst düzeyde devamlılığını amaçlıyor.
Hastanemiz Sosyal Güvenlik Kurumu tarafından belirlenen “ A sınıfı hastane” ünvanını almaya hak kazanmıştır. Sosyal güvenlik kurumu ve birçok kuruluşla tedavi protokolü bulunmaktadır. Hastanemiz 7 gün 24 saat hizmet vermektedir. Poliklinik hizmetleri Sabah 08:00 Akşam 17:00 arasında alınabilir. Cumartesi günü ise Sabah 08:00 – 12:00 arası muayene yapılmaktadır."
                buttonText="Devamını Oku"
                imagePosition="left"
                titleColor="#2cadd2"
                buttonColor="#2cadd2"
            />

            <CallToActionBanner
                title="Dileğimiz; Çocuksuz Aile Kalmasın!"
                description="Tüp Bebek Randevu Hattı (0344) 231 62 62 detaylı bilgi alabilirsiniz."
                buttonText="Bizimle İletişime Geçin"
                buttonLink="/iletisim"
                backgroundColor="#f5f5f7"
                titleColor="#1a1a1a"
                descriptionColor="#666"
                buttonColor="#2cadd2"
            />

            <BlogCardsSection
                title="Kadın Hastalıkları"
                cards={kadinHastaliklariBlogCards}
                titleColor="#2cadd2"
                buttonColor="#2cadd2"
                accentColor="#2cadd2"
            />

            <HormoneTestsSlider
                title="Hormon Testleri"
                items={hormoneTests}
                titleColor="#2cadd2"
                buttonColor="#2cadd2"
                accentColor="#2cadd2"
            />

            <BlogCardsSection
                title="Balanslama"
                cards={balanslamaCards}
                titleColor="#2cadd2"
                buttonColor="#2cadd2"
                accentColor="#2cadd2"
            />
        </>
    );
};

export default TupBebekPage;